import { Link, useSearchParams } from "react-router-dom";
import { useApi } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { ListingCard } from "@/components/site/ListingCard";
import { useLang } from "@/lib/i18n";

const FILTERS = [
  { id: "all", label: "filter.all" },
  { id: "home", label: "filter.home" },
  { id: "ranch", label: "filter.ranch" },
  { id: "land", label: "filter.land" },
];

export const FilterPills = ({ options, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${prefix}-filters`}>
    {options.map((f) => (
      <button key={f.id} onClick={() => onChange(f.id)} data-testid={`${prefix}-filter-${f.id}`}
        className={`rounded-full border-2 px-5 py-2 text-sm font-bold transition-colors duration-200 ${value === f.id ? "border-forest bg-forest text-white" : "border-clay text-ink hover:border-forest"}`}>
        {f.label}
      </button>
    ))}
  </div>
);

export default function HomesForSale() {
  const { t, to } = useLang();
  const [params, setParams] = useSearchParams();
  const cat = params.get("category") || "all";
  const { data, loading } = useApi("/listings?kind=sale", []);
  const items = cat === "all" ? data : data.filter((l) => l.category === cat);
  return (
    <>
      <Seo title={t("homes.seoTitle")} description={t("homes.seoDesc")} />
      <PageHeader testId="homes-header" eyebrow={t("homes.eyebrow")} title={t("homes.title")}>
        {t("homes.intro")}
      </PageHeader>
      <section className="container-x pb-28">
        <FilterPills prefix="homes" options={FILTERS.map((f) => ({ ...f, label: t(f.label) }))} value={cat} onChange={(v) => setParams(v === "all" ? {} : { category: v })} />
        {!loading && items.length === 0 && (
          <div className="mt-12 rounded-2xl border border-dashed border-sage bg-linen p-10" data-testid="homes-empty">
            <h3 className="font-display text-2xl font-black text-forest">{t("homes.emptyTitle")}</h3>
            <p className="mt-2 font-medium text-moss">{t("homes.emptyText")}</p>
            <Link to={to("/contact")} className="btn-primary mt-6" data-testid="homes-empty-contact">{t("homes.emptyCta")}</Link>
          </div>
        )}
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="homes-grid">
          {items.map((l, i) => (
            <Reveal key={l.slug} delay={(i % 3) * 0.08}><ListingCard listing={l} /></Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
